import {
  CAMERA_PRESENTER,
  SOURCE_ROLE_SPEAKER,
  SOURCE_ROLE_HOST
} from '@shoflo/polymer';
import { UNASSIGNED } from '@studio/constants/Sources';

export function getSpeakerSources(sources) {
  return sources.filter(
    source =>
      source.role === SOURCE_ROLE_SPEAKER &&
      'user' in source &&
      source.type === CAMERA_PRESENTER &&
      source.value !== UNASSIGNED
  );
}

export function getHostSources(sources) {
  return sources.filter(
    source =>
      source.role === SOURCE_ROLE_HOST &&
      'user' in source &&
      source.type === CAMERA_PRESENTER &&
      source.value !== UNASSIGNED
  );
}
